import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'psifiston';
const args = {};

export class Psifiston extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
